// License keys extension (admin side): the keys of a license-key product and
// the platforms they are redeemed on. `bookSettings.platforms` is this
// extension's field in the store product model, so the Platforms tab of the
// catalog editor lives here next to the key list; both are reused as they
// are.
import { KeyIcon } from "@heroicons/react/24/outline"
import LicenseKeysTab from "./LicenseKeysTab"
import PlatformsTab from "../shared/PlatformsTab"
import { CatalogEditorProvider, catalogTabsSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "license-keys",
  label: "License Keys",
  description: "The license keys of the product and the platforms they are redeemed on",
  section: {
    component: catalogTabsSection([
      { key: "keys", label: "License Keys", Tab: LicenseKeysTab },
      { key: "platforms", label: "Platforms", Tab: PlatformsTab },
    ]),
    label: "License Keys",
    icon: KeyIcon,
    order: 530,
    visible: catalogVisible("keys", "platforms"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
